module.exports = __webpack_public_path__ + "media/images/pepsi_home/location-icon-d5224216dcf96cab0d801c6b70638112.png";